// CANONICAL COPY (GH #7115). src/constants/obligations/obl-software-installation.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-software-installation',
  title: 'Review software installation controls',
  description:
    'Confirm that procedures and measures control the installation of software on operational systems, including authorisation requirements, allow/deny-lists for applications and services, and restrictions on user-initiated installations. Review exceptions and compensating controls.',
  category: 'technical',
  scfIds: ['SCF-OPS-010'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Software installation / allow-list policy is published',
    },
    { type: 'document-within-sla', description: 'Policy review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
